/**
 * 生成 UUID
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 获取根域名（用于设置跨子域 cookie）
 * 例如：a.Rocnovel.net -> .Rocnovel.net
 */
function getRootDomain() {
  const hostname = window.location.hostname
  const parts = hostname.split('.')

  // 如果是 localhost 或 IP 地址，直接返回
  if (parts.length <= 2 || /^\d+\.\d+\.\d+\.\d+$/.test(hostname))
    return hostname

  // 返回根域名，例如 .Rocnovel.net
  return `.${parts.slice(-2).join('.')}`
}

/**
 * 设置 Cookie
 */
function setCookie(name: string, value: string, days = 365) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  const domain = getRootDomain()
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;domain=${domain}`
}

/**
 * 获取 Cookie
 */
function getCookie(name: string) {
  const match = document.cookie.match(new RegExp(`(^|;)\\s*${name}=([^;]*)`))
  return match ? decodeURIComponent(match[2]) : null
}

/**
 * 获取或创建设备 ID
 * 返回 { equipmentId, isNewUser }
 */
export function getOrCreateEquipmentId() {
  let equipmentId = getCookie('equipmentId')
  let isNewUser = false

  if (!equipmentId) {
    equipmentId = generateUUID()
    setCookie('equipmentId', equipmentId)
    isNewUser = true
    // 标记为新用户，存储在全局变量中
    window.__isNewUser = true
  }
  else {
    window.__isNewUser = window.__isNewUser || false
  }

  try {
    sessionStorage.setItem('is-new-user', isNewUser ? 'yes' : 'no')
  }
  catch (error) {
    // sessionStorage 不可用，可能是隐私模式
  }

  return { equipmentId, isNewUser }
}

/**
 * 判断是否是新用户（UV）
 */
export function isNewUser() {
  return window.__isNewUser === true
}

/**
 * 上报 Clarity 事件
 * 新用户上报 UV + PV，老用户只上报 PV
 */
export function reportClarity(eventName: string) {
  if (window.clarity) {
    const equipmentId = getCookie('equipmentId')
    if (!equipmentId)
      return

    // 新用户上报 UV 事件
    if (isNewUser())
      window.clarity('event', `${eventName} UV`)

    // 所有用户都上报 PV 事件
    window.clarity('event', `${eventName} PV`)
  }
}
